import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useMeta } from 'vue-meta'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffirmFailed',
  setup(__props, { expose }) {
  expose();

useMeta({ title: 'Payment cancelled' })
const route = useRoute()
const statusMessage = computed(() => route.query?.status)

const __returned__ = { route, statusMessage, computed, useRoute, useMeta }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})